import { render } from "./ReportDetailModal.vue?vue&type=template&id=04d10502"
import script from "./ReportDetailModal.vue?vue&type=script&lang=ts"
export * from "./ReportDetailModal.vue?vue&type=script&lang=ts"
script.render = render

export default script